import { render, staticRenderFns } from "./match.vue?vue&type=template&id=1547c46b&"
import script from "./match.vue?vue&type=script&lang=js&"
export * from "./match.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports